import type { ReactElement, SVGProps } from "react";

export function MarketplacePlugIcon(
  props: SVGProps<SVGSVGElement>
): ReactElement {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      aria-hidden
      {...props}
    >
      <path d="M9 2v6M15 2v6M7 8h10v6a5 5 0 01-10 0V8zM12 19v3" />
    </svg>
  );
}
